// 引入 ElMessage 组件
import "element-plus/es/components/message/style/css";
import { ElMessage } from "element-plus";
//'success' | 'warning' | 'info' | 'error'
export function useMessage(message,type="success",dangerouslyUseHTMLString=false) {
    ElMessage({
    showClose: true,
    message,
    type,
    duration: 3000,
    dangerouslyUseHTMLString,
  })
  return ElMessage;
}
